export type SiteConfig = typeof siteConfig;

export const EXTERNAL_API_URL = 'https://api.craquestats.com.br';

export const DOMAIN_FOR_COOKIES = '.' + window.location.host.split(':')[0];

export const burl = (endpoint: string) => {
  if (endpoint.includes('not_premium_endpoints')) return endpoint;
  let origin = (window.location.origin.includes('localhost') || window.location.origin.includes('ngrok') || window.location.origin.includes('-test-dev')) ? window.location.origin : EXTERNAL_API_URL;
  if (endpoint.startsWith('/')) {
    endpoint = endpoint.slice(1);
  }
  return `${origin}/${endpoint}`;
}


export const siteConfig = {
  name: "Craque Stats",
  description: "Make beautiful websites regardless of your design experience.",
  navItems: [
    {
      label: "Home",
      href: "/",
    },
    {
      label: "Docs",
      href: "/docs",
    },
    {
      label: "Pricing",
      href: "/pricing",
    },
    {
      label: "Blog",
      href: "/blog",
    },
    {
      label: "About",
      href: "/about",
    },
  ],
  navMenuItems: [
    {
      label: "Profile",
      href: "/profile",
    },
    {
      label: "Dashboard",
      href: "/dashboard",
    },
    {
      label: "Projects",
      href: "/projects",
    },
    {
      label: "Team",
      href: "/team",
    },
    {
      label: "Calendar",
      href: "/calendar",
    },
    {
      label: "Settings",
      href: "/settings",
    },
    {
      label: "Help & Feedback",
      href: "/help-feedback",
    },
    {
      label: "Logout",
      href: "/logout",
    },
  ],
  links: {
    github: "https://github.com/nextui-org/nextui",
    twitter: "https://twitter.com/getnextui",
    docs: "https://nextui.org",
    discord: "https://discord.gg/9b6yyZKmH4",
    sponsor: "https://patreon.com/jrgarciadev",
  },
};